export function getDayString(date) {
    if (date === null) {
        return null;
    }

    let str = date.getFullYear();
    str += "-";
    let month = (date.getMonth() + 1);
    str += (month < 10 ? ("0" + month) : month);
    str += "-";
    let day = date.getDate();
    str += (day < 10 ? ("0" + day) : day);
    return str;
}

export function getCurrentDayString() {
    let day = getCurrentDate();
    return getDayString(day);
}

export function getTimeString(date) {
    if (date === null) {
        return null;
    }

    let hour = date.getHours();
    let str = (hour < 10 ? ("0" + hour) : hour);
    str += "h";
    let minute = date.getMinutes();
    str += (minute < 10 ? ("0" + minute) : minute);
    return str;
}

export function getCurrentTimeString() {
    let day = getCurrentDate();
    return getTimeString(day);
}

export function getClockString(date) {
    if (date === null) {
        return null;
    }

    let hour = date.getHours();
    let str = (hour < 10 ? ("0" + hour) : hour);
    str += ":";
    let minute = date.getMinutes();
    str += (minute < 10 ? ("0" + minute) : minute);
    str += ":";
    let second = date.getSeconds();
    str += (second < 10 ? ("0" + second) : second);
    return str;
}

export function getCurrentClockString() {
    let day = getCurrentDate();
    return getClockString(day);
}

export function getCurrentDateString() {
    return getDateString(getCurrentDate());
}

export function getDateString(date) {
    return getDayString(date) + " " + getClockString(date);
}

export function getDisplayDateFr(date) {
    if (date === null || date === undefined) {
        return null;
    }

    let options = {weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'};
    return date === null ? null : date.toLocaleDateString('fr-FR', options);
}

export function getDisplayDateFrShort(date) {
    if (date === null || date === undefined) {
        return null;
    }

    let tdt = new Date(date.valueOf());
    let options = {weekday: 'short', month: 'numeric', day: 'numeric'};
    return tdt.toLocaleDateString('fr-FR', options);
}

export function getDisplayDateFrLong(date) {
    if (date === null || date === undefined) {
        return null;
    }

    let options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
    return date === null ? null : date.toLocaleDateString('fr-FR', options);
}

export function getCurrentDisplayDate() {
    let day = getCurrentDate();
    return getDisplayDateFr(day);
}

export function getCurrentTime(txt_date, withoutSeconds = false){
    return getTimeFromDayAndTime(txt_date, getCurrentDate(withoutSeconds));
}

export function getTimeFromDayAndTime(txt_date,time){
    let day = textDayToDate(txt_date);
    day.setHours(time.getHours(),time.getMinutes(),time.getSeconds(), time.getMilliseconds());
    return day;
}

export function getCurrentDate(withoutSeconds = false) {
    let date = new Date();

    if(withoutSeconds){
        date = new Date(date.setSeconds(0));
        date = new Date(date.setMilliseconds(0));
    }

    return date;
}

export function getWeekNumber(day) {
    let tdt = new Date(day.valueOf());
    let dayn = (day.getDay() + 6) % 7;
    tdt.setDate(tdt.getDate() - dayn + 3);
    let firstThursday = tdt.valueOf();
    tdt.setMonth(0, 1);

    if (tdt.getDay() !== 4) {
        tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
    }

    let week = 1 + Math.ceil((firstThursday - tdt) / 604800000);
    return week + "-" + tdt.getUTCFullYear();
}
export function getLastWeekNumber(day) {
    let tdt = new Date(day.valueOf());
    tdt.setDate(tdt.getDate() - 7);
    let dayn = (day.getDay() + 6) % 7;
    tdt.setDate(tdt.getDate() - dayn + 3);
    let firstThursday = tdt.valueOf();
    tdt.setMonth(0, 1);

    if (tdt.getDay() !== 4) {
        tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
    }

    let week = 1 + Math.ceil((firstThursday - tdt) / 604800000);
    return week + "-" + tdt.getUTCFullYear();
}

export function textDayToDate(txt) {
    if (txt === null) {
        return null;
    }

    return new Date(Date.parse(txt));
}

export function textHourToDate(txt) {
    if (txt === null) {
        return null;
    }

    let dt = getCurrentDate();
    dt.setHours(Number(txt.substring(0, 2)), Number(txt.substring(3, 5)));
    return dt;
}


export function plusOneDay(txt_day) {
    if (txt_day === null) {
        return null;
    }

    var day = textDayToDate(txt_day);
    day.setDate(day.getDate() + 1);
    return getDayString(day);
}

export function minusOneDay(txt_day) {
    if (txt_day === null) {
        return null;
    }

    var day = textDayToDate(txt_day);
    day.setDate(day.getDate() - 1);
    return getDayString(day);
}

export function getEndOfDay(txt_date) {
    let day = textDayToDate(txt_date);
    day.setHours(23, 59, 0);
    return day;
}

export function getStartOfDay(txt_date) {
    let day = textDayToDate(txt_date);
    day.setHours(0, 0, 0);
    return day;
}

export function timeToFloat(hours, minutes){
    return hours + minutes / 60;
}

export function convertToMs(timefloat) {
    // Get the minutes portion
    let reminder = timefloat % 1;

    // Convert into ms
    let minutes = reminder * 100 * 60 * 1000;

    // Get the number of hours and convert to ms
    let hours = (timefloat - reminder) * 60 * 60 * 1000;

    return minutes + hours;
}

export function floatToTime(hours){

    let reminder = hours % 1;
    let minutesNb = Math.round(reminder * 60);

    // Get the number of hours and convert to ms
    let hoursNb = (hours - reminder);
    return new Date(0, 0, 1, hoursNb, minutesNb, 0);
}
